var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide"}},[(_vm.show)?_c('v-card',{staticClass:"drawer financial-drawer elevation-7 gray-7--text"},[_c('employee-list',{on:{"closeDrawer":_vm.closeDrawer}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }